import { render } from "./ClientVentas.vue?vue&type=template&id=0b14938e&scoped=true"
import script from "./ClientVentas.vue?vue&type=script&lang=js"
export * from "./ClientVentas.vue?vue&type=script&lang=js"

import "./ClientVentas.vue?vue&type=style&index=0&id=0b14938e&scoped=true&lang=css"
import "./ClientVentas.vue?vue&type=style&index=1&id=0b14938e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b14938e"]])

export default __exports__